import axios from 'axios';
import {
  FETCH_BALANCES_SUCCESS,
  FETCH_BALANCES_FAIL,
  FETCH_DAILY_PRICES_SUCCESS,
  FETCH_DAILY_PRICES_FAIL,
  FETCH_LAST_LOGIN_VALUE_SUCCESS,
  FETCH_LAST_LOGIN_VALUE_FAIL,
  FETCH_FX_SNAPSHOT_DAY_SUCCESS,
  FETCH_FX_SNAPSHOT_DAY_FAIL,
  FETCH_FX_SNAPSHOT_WEEK_SUCCESS,
  FETCH_FX_SNAPSHOT_WEEK_FAIL,
} from './types';

export const fetchBalance = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/balances';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_BALANCES_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_BALANCES_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_BALANCES_FAIL });
  }
};

export const fetchDailyPrices = (params) => async (dispatch) => {
  const url = '/fx/daily';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_DAILY_PRICES_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_DAILY_PRICES_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_DAILY_PRICES_FAIL });
  }
};

export const fetchLastLoginValue = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/stats/lastfx';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_LAST_LOGIN_VALUE_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_LAST_LOGIN_VALUE_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_LAST_LOGIN_VALUE_FAIL });
  }
};

export const fetchFxSnapshot = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/fx/snapshot';
  let success = FETCH_FX_SNAPSHOT_DAY_SUCCESS;
  let fail = FETCH_FX_SNAPSHOT_DAY_FAIL;
  if (params && params.period) {
    switch (params.period) {
      case '7days':
        success = FETCH_FX_SNAPSHOT_WEEK_SUCCESS;
        fail = FETCH_FX_SNAPSHOT_WEEK_FAIL;
        break;
      case '24hrs':
        success = FETCH_FX_SNAPSHOT_DAY_SUCCESS;
        fail = FETCH_FX_SNAPSHOT_DAY_FAIL;
        break;
      default:
        success = FETCH_FX_SNAPSHOT_DAY_SUCCESS;
        fail = FETCH_FX_SNAPSHOT_DAY_FAIL;
        break;
    }
  }
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: success, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: fail, errors: error });
    }
    return dispatch({ type: fail });
  }
};
